export default {
  text: {
    en: `
      We are happy to announce our partnership with some great makeup brands. 
      Makeup products are part of the Scentbird experience, just add them to your queue. 
      All makeup is Limited Quantities only, so hurry!
    `,
  },
  buttonTitle: {
    en: 'Try now',
  },
}
